module.exports = __webpack_public_path__ + "img/getraenke.97da9992.jpg";